var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true,"height":2}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }